import React, { useState, useEffect } from "react";

const heroSlides = [
    // {
    //     image: "assets/new-images/TBR_1653.JPG",
    //     alt: "Founder speaking at tech event",
    //     position: "top center"
    // },
    // {
    //     image: "assets/new-images/_MG_5596.jpg",
    //     alt: "Innovation showcase - handmade cars at tech event",
    //     position: "center"
    // },
    // {
    //     image: "assets/new-images/_MG_5654.jpg",
    //     alt: "ATH event group photo",
    //     position: "top"
    // },
    // {
    //     image: "assets/new-images/_MG_5680.jpg",
    //     alt: "Audience at ATH tech event",
    //     position: "top center"
    // },
    {
        image: "assets/new-images/IMG_2913.jpg",
        alt: "Audience at ATH tech event",
        position: "top center"
    },
    {
        image: "assets/new-images/IMG_3261.jpg",
        alt: "Audience at ATH tech event",
        position: "top center"
    },
    {
        image: "assets/new-images/IMG_3263.jpg",
        alt: "Audience at ATH tech event",
        position: "top center"
    },
    {
        image: "assets/new-images/IMG_2861.jpg",
        alt: "Founder presenting at event",
        position: "top"
    },
];

const Hero = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [showVideo, setShowVideo] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide(prev => (prev + 1) % heroSlides.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <section className="revamp-hero">
            {/* Background image carousel with crossfade */}
            <div className="revamp-hero__carousel">
                {heroSlides.map((slide, index) => (
                    <div
                        key={index}
                        className={`revamp-hero__slide ${index === currentSlide ? 'active' : ''}`}
                        style={{ backgroundImage: `url('${slide.image}')`, backgroundPosition: slide.position }}
                        aria-label={slide.alt}
                    />
                ))}
                <div className="revamp-hero__overlay" />
            </div>

            {/* Background grid dots */}
            <div className="revamp-hero__grid"></div>

            {/* Floating gradient orbs */}
            <div className="revamp-hero-orb revamp-hero-orb--purple"></div>
            <div className="revamp-hero-orb revamp-hero-orb--teal"></div>

            <div className="container">
                <div className="row align-items-center">
                    <div className="col-12 col-lg-7 mt-5 mt-lg-0 order-1 order-lg-1 text-center text-lg-start">
                        <div className="revamp-hero__badge">
                             Innovation • Technology • Entrepreneurship
                        </div>
                        <h1 className="revamp-hero__title">
                            Welcome To The <span className="gradient-text">New</span> Eastern <span className="gradient-text">Tech</span> Journey
                        </h1>
                        <p className="revamp-hero__subtitle">
                          Building talent. Powering innovation. Growing the future of tech
                        </p>
                        {/* <div className="revamp-hero__actions">
                            <a href="/services" className="revamp-btn revamp-btn--primary">
                                Our Services <i className="fas fa-arrow-right"></i>
                            </a>
                            <a href="/about" className="revamp-btn revamp-btn--outline">
                                Learn More <i className="fas fa-arrow-right"></i>
                            </a>
                        </div> */}
                    </div>
                    <div className="col-lg-5 col-12 order-2 order-lg-2 text-center">
                        <div className="revamp-hero__visual">
                            <div className="revamp-hero__visual-ring">
                                <div className="revamp-hero__visual-core" onClick={() => setShowVideo(true)} style={{cursor: 'pointer'}}>
                                    <i className="fas fa-play"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Slide indicators */}
            <div className="revamp-hero__indicators">
                {heroSlides.map((_, index) => (
                    <button
                        key={index}
                        className={`revamp-hero__indicator ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => setCurrentSlide(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
            {/* Video Modal */}
            {showVideo && (
                <div className="revamp-video-modal" onClick={() => setShowVideo(false)}>
                    <div className="revamp-video-content" onClick={e => e.stopPropagation()}>
                        <button className="revamp-video-close" onClick={() => setShowVideo(false)}>
                            <i className="fas fa-times"></i>
                        </button>
                        <div className="revamp-video-wrapper">
                            <iframe 
                                src="https://www.youtube.com/embed/JEduhSu3nvg?autoplay=1" 
                                title="YouTube video player" 
                                frameBorder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}
        </section>
    )
}
export default Hero;